import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GroupedCheckboxComponent } from './grouped-checkbox.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [GroupedCheckboxComponent],
    exports: [GroupedCheckboxComponent],
    providers: []
})

export class GroupedCheckboxModule { }
